import { render } from "./LibPeer.vue?vue&type=template&id=3b77dd4d&scoped=true"
import script from "./LibPeer.vue?vue&type=script&lang=js"
export * from "./LibPeer.vue?vue&type=script&lang=js"

import "./LibPeer.vue?vue&type=style&index=0&id=3b77dd4d&scoped=true&lang=css"

import exportComponent from "/home/heather/Documents/Work/Soldel/pwa2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b77dd4d"]])

export default __exports__